import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export class EdDmyParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (!value) return null;
        const v = value.trim();
        const m = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2}|\d{4})$/.exec(v);
        if (!m) return null;

        const day = +m[1];
        const month = +m[2];
        const yy = +m[3];
        const year = m[3].length === 2 ? (yy >= 70 ? 1900 + yy : 2000 + yy) : yy;

        if (month < 1 || month > 12) return null;
        if (day < 1 || day > 31) return null;

        return { year, month, day };
    }

    format(date: NgbDateStruct | null): string {
        if (!date) return '';
        return `${date.day}/${date.month}/${date.year}`;
    }
}
